<template>
  <div class="nav">
    <div class="nav-item return-box" @click="returnLast" v-if="int">
      <svg class="icon-svg return-icon" @click="returnList">
        <use xlink:href="#icon-youjiantou-cu" />
      </svg>
      <span>返回</span>
    </div>
    <div class="nav-item logo-box" :class="{ hide: (!currentClass && ptype != 'person') || platformType == 'sz' }"
      v-else-if="!isDesktop">
      <div class="logo-title">
        <div class="crumb-box" v-if="currentClass || ptype == 'person'">
          <a-tooltip title="返回首页" v-if="!isSharer">
            <svg class="icon-home icon-svg" @click="returnHome" :style="{ '--hover-color': nav_theme_color }">
              <use xlink:href="#icon-home" />
            </svg>
          </a-tooltip>
          <svg class="crumb-icon icon-svg" v-if="currentClass && !isSharer">
            <use xlink:href="#icon-shuzijiaocaitubiao-07" />
          </svg>
          <span v-if="currentClass">{{ currentClass.ClassName }}</span>
        </div>
      </div>
    </div>

    <div class="desktop-function" v-if="isDesktop">
      <svg @click="ipcRenderer.send('window:minimize')">
        <use xlink:href="#icon-zuixiaohua" />
      </svg>
      <svg @click="ipcRenderer.send('window:maximize');">
        <use xlink:href="#icon-zuidahua1" />
      </svg>
      <svg class="icon-guanbi" @click="deskTopClose()">
        <use xlink:href="#icon-close-line" />
      </svg>
    </div>

    <div class="nav-right">
      <div class="nav-item note-box" v-if="currentClass && !isLocal && !isSharer">
        <template v-if="platformType == 'sz'">
          <div class="svg-box" :class="{ 'actived': pilotNavOpen == 'search' }" @click="openTab('search')">
            <a-tooltip>
              <template #title>搜索</template>
              <svg class="icon-svg" style="transform: scale(1.2);">
                <use xlink:href="#icon-shuzijiaocaitubiao-11" />
              </svg>
            </a-tooltip>
          </div>

          <div class="svg-box" :class="{ 'actived': pilotNavOpen == 'knowledgeGraph' }" v-if="knowledgeGraph"
            @click="openTab('knowledgeGraph')">
            <a-tooltip>
              <template #title>知识图谱</template>
              <svg class="icon-svg">
                <use xlink:href="#icon-graph" />
              </svg>
            </a-tooltip>
            <i class="dot" v-if="newReply > 0"></i>
          </div>
          <div class="svg-box" :class="{ 'actived': pilotNavOpen == 'question' }" @click="openTab('question')">
            <a-tooltip>
              <template #title>疑问</template>
              <svg class="icon-svg">
                <use xlink:href="#icon-question" />
              </svg>
            </a-tooltip>
            <i class="dot" v-if="newReply > 0"></i>
          </div>
          <a-tooltip class="svg-box" :class="{ 'actived': pilotNavOpen == 'note' }" @click="openTab('note')">
            <template #title>笔记</template>
            <svg class="icon-svg">
              <use xlink:href="#icon-note" />
            </svg>
          </a-tooltip>
          <a-tooltip class="svg-box" :class="{ 'actived': pilotNavOpen == 'card' }" @click="openTab('card')">
            <template #title>知识卡片</template>
            <svg class="icon-svg" :style="{ 'font-size': '24px', 'margin': '0 3px' }"
              v-if="currentClass && ['0d2a6e80-b99e-11ee-a1d8-3f479df4d981', 'e3ca3fa0-f7e8-11ee-88a6-7d54a331e71f'].includes(currentClass.PK_ClassGuid)">
              <use xlink:href="#icon-card2" />
            </svg>
          </a-tooltip>
        </template>

        <template v-else>
          <a-tooltip class="svg-box" @click="openGroup = true" v-if="myTeam">
            <template #title>我的团队</template>
            <svg class="icon-achievement icon-svg">
              <use xlink:href="#icon-team" />
            </svg>
          </a-tooltip>
          <a-tooltip class="svg-box" @click="openRank = true">
            <template #title>排行榜</template>
            <div>
              <svg class="icon-achievement icon-svg">
                <use xlink:href="#icon-rank" />
              </svg>
            </div>
          </a-tooltip>
          <a-tooltip class="svg-box" :class="{ 'actived': pilotNavOpen == 'achievement' }"
            @click="openTab('achievement')">
            <template #title>学习成就</template>
            <div class="achievement-box">
              <span>{{ levelInfo?.achievement.length || 0 }}</span>
              <svg class="icon-achievement icon-svg">
                <use xlink:href="#icon-badge" />
              </svg>
            </div>
          </a-tooltip>
        </template>
      </div>

      <div class="level-box nav-item"
        v-if="currentClass && levelInfo && !isSharer && platformType != 'sz' && fromType != 'train'"
        :style="{ color: nav_theme_color }">
        <div class="level-text">等级</div>
        <div class="user-level">
          <span>LV.{{ levelInfo?.value || 0 }}</span>
          <a-progress class="level-progress" :strokeColor="nav_theme_color" :percent="levelInfo?.EXPProcess"
            :strokeWidth="5" :show-info="false" />
          <span class="level-value" v-if="levelInfo?.upgradeEXP">{{ levelInfo?.EXP }}/{{ levelInfo?.upgradeEXP }}</span>
        </div>
      </div>
      <div class="user-box" v-if="user && fromType != 'yuanxi' && fromType != 'train'">
        <!-- <a-tooltip>
          <template #title>帮助</template>
          <svg class="icon-svg icon-bangzhu" @click="openHelp = true">
            <use xlink:href="#icon-help" />
          </svg>
        </a-tooltip>-->
        <a-dropdown :trigger="['click']">
          <i class="icon-i avatar" :style="{ backgroundImage: 'url(' + user?.HeadPhotoPath + ')' }"></i>
          <template #overlay>
            <a-menu>
              <a-menu-item @click="routerPersonal()" v-if="!isSharer">
                <span>个人中心</span>
              </a-menu-item>
              <a-menu-item @click="logout()">
                <span>退出登录</span>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
    </div>
  </div>

  <achievementBox @closeBox="openAchievement = false" v-if="openAchievement" />
  <teamBox @closeBox="openGroup = false" v-if="openGroup"></teamBox>
  <helpBox @closeBox="openHelp = false" v-if="openHelp"></helpBox>
  <rank @closeBox="openRank = false" v-if="openRank"></rank>

</template>

<script>
import { PASSPORT_CLIENT_SERVER, LESSONPLAY_TOKEN } from '../../config/url';
import achievementBox from "../achievement/achievement-box/achievement-box.vue";
import teamBox from "../team-box/team-box.vue";
import helpBox from "./help-box/help-box.vue";
import pilotAchievement from "@/components/list/pilot-list/pilot-achievement/pilot-achievement.vue";
import rank from "@/components/list/Rank.vue";

import { mapState } from 'vuex'

export default {
  name: "navroot",
  components: {
    achievementBox, teamBox, helpBox, pilotAchievement, rank
  },
  props: {
    ptype: String
  },
  data() {
    return {
      user: null,
      currentClass: null,
      int: null,
      levelInfo: null,
      ipcRenderer: null,
      platform: null,
      myTeam: null,

      platformType: "",
      online_url: "",
      fromType: "",
      nav_theme_color: "",
      returnUrl: "",

      isDesktop: false,
      isSharer: false,
      isLocal: false,
      openAchievement: false,
      openGroup: false,
      openHelp: false,
      openRank: false,

      pilotNavOpen: '',
      newReply: 0,
    }
  },
  computed: {
    ...mapState({
      knowledgeGraph: state => state.knowledgeGraph,
    }),
  },
  async mounted() {
    let { type } = this.$route.params;

    this.platformType = type;
    this.online_url = `${PASSPORT_CLIENT_SERVER}/shell/${type}`;

    this.isDesktop = !!(window && window.process && window.process.type);
    if (this.isDesktop) {
      const { ipcRenderer } = window.require('electron');
      this.ipcRenderer = ipcRenderer;
    }

    let { userInfo, platform, currentClass, isSharer, fromType, returnUrl, isLocal } = this.$store.state;
    if (!userInfo) return;
    if (!userInfo.Phone || !userInfo.StudentID || !userInfo.School) this.openNotification();

    this.user = userInfo;
    this.currentClass = currentClass;
    this.nav_theme_color = platform.pageConfig.nav_theme_color || '#fc9399';
    this.isSharer = isSharer;
    this.fromType = fromType;
    this.returnUrl = returnUrl;
    this.isLocal = isLocal;

    this.$store.subscribe((res) => {
      if (!res) return;
      let { type, payload } = res;

      if (type == "currentClass" && payload) {
        this.currentClass = payload;
        document.title = payload.ClassName;

      }
      if (type == "levelInfo") this.levelInfo = payload;
      if (type == "myTeamList") this.myTeam = payload.length > 0 ? payload[0] : null;

      if (type == "newReply") this.newReply = payload;
      if (type == "pilotNavOpen") this.pilotNavOpen = payload;
      if (type == 'currentInt') this.int = payload;
    })

    this.platform = platform;
  },
  methods: {
    //提示信息
    openNotification() {
      this.$notification.open({
        message: '提示',
        description: '您的个人信息不完善！请完善个人信息',
        top: '50px',
      })
    },
    //退出
    logout() {
      this.$nzconfirm('确定要退出账号吗?', () => {
        let token = window.localStorage.getItem(LESSONPLAY_TOKEN);
        window.localStorage.removeItem(LESSONPLAY_TOKEN);
        location.href = `${PASSPORT_CLIENT_SERVER}/auth/logout?token=${token}&redirectURI=${this.online_url}&isTourist=true`;
      })
    },
    //跳转至个人中心
    routerPersonal() {
      this.$router.push(`/${this.platformType}/person-center`);
    },
    //跳转首页
    returnHome() {
      if (this.returnUrl) return window.location.href = this.returnUrl;
      else if (this.fromType == 'yuanxi') return window.location.href = 'https://yuanxi.online';
      else if (this.fromType == 'train') return window.location.href = 'https://inner-training.lessonplan.cn';

      this.$store.commit('currentClass', null);
      this.$router.push(`/${this.platformType}/classlist`);
    },
    //返回上一页
    returnLast() {
      const path = this.$route.path;
      this.$router.push({ path: path, query: { intId: undefined } });
      this.$store.commit('currentInt', null);
    },
    //桌面退出
    deskTopClose() {
      this.$nzconfirm('确定要关闭窗口吗?', () => {
        this.ipcRenderer.send('window:close')
      })
    },
    //打开菜单
    openTab(tab) {
      if (this.platformType != 'sz') {
        if (tab === 'achievement') this.openAchievement = true;
      } else {
        if (this.pilotNavOpen == tab) this.$store.commit('pilotNavOpen', '');
        else this.$store.commit('pilotNavOpen', tab);
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "./nav.scss";
</style>